/*
 * @Description:
 * @Author: zhanjunwei
 * @Date: 2024-12-04 16:35:56
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2024-12-31 14:38:57
 */
'use client';
import { useEffect } from 'react';
import {
  IState,
  useLocalGlobalStore,
  getClientUserInfoApi,
  getMobile,
  mobileRealNameUrl,
  mobilePaths,
} from '@ssv-website/hooks';
const useUserInfo = () => {
  const { setState, clear } = useLocalGlobalStore((s) => s);
  const { href } = window.location;
  const { searchParams } = new URL(href);
  const skip = searchParams.get('s_realname_skip'); // 是否跳过登录
  const from: any = searchParams.get('s_from'); // 返回的来源
  const isMobile = getMobile();

  // 过滤路由
  const noUserInfoList = ['/login'];

  // 获取并更新用户信息
  const getUserInfo = async () => {
    const { data } = await getClientUserInfoApi();
    if (!data) {
      return clear();
    }
    const { real_status, info, hasTeam } = data;
    // 记录是否跳过实名
    const id = `realname_skip_${data?.info.GUID}`;
    if (real_status) {
      localStorage.removeItem(id);
      // 登录后，如果是移动端用户，并且已经实名并且有团队，则选择团队
      if (from === 'coral_login' && isMobile && hasTeam) {
        window.location.href = mobilePaths({ redirectUrl: href }).teamPath;
        return;
      }
    } else {
      const res = await handleSkipRealName(id, hasTeam);
      if (res !== 'success') return;
    }

    const isSkipRealName = localStorage.getItem(id) === '1';
    const userName = real_status ? info.IDCard.Name : info.Name || info.Phone;
    setState((p: Omit<IState, 'setState'>) => {
      return {
        ...p,
        ...(data || {}),
        userName,
        is_login: true,
        is_skip_real_name: isSkipRealName,
      };
    });
  };

  // 记录跳过实名
  const handleSkipRealName = (id: string, hasTeam: boolean) => {
    const p = new Promise((resolve, reject) => {
      const isSkipRealname = localStorage.getItem(id) !== '1';
      // 如果是从登录页回来，并且是移动端没有跳过实名，则到实名页
      if (from === 'coral_login' && isMobile && isSkipRealname) {
        window.location.href = mobileRealNameUrl(window.location.href);
        return;
      }
      // 设置跳过实名
      if (skip === '1') {
        localStorage.setItem(id, '1');
      }
      // 登录后，如果是移动端用户，从实名页回来，并且有团队
      if (
        ['coral_realname', 'coral_login'].includes(from) &&
        isMobile &&
        hasTeam
      ) {
        window.location.href = mobilePaths({ redirectUrl: href }).teamPath;
        return;
      }
      resolve('success');
    });
    return p;
  };

  useEffect(() => {
    const { pathname, href } = window.location;
    const { searchParams } = new URL(href);
    const action = searchParams.get('s_action'); // 团队跳转回来

    // 如果是新建团队 提高优先级
    if (action === 'createOrganization') {
      window.location.href = '/team/preposition';
      return;
    }
    if (!noUserInfoList.includes(pathname)) {
      getUserInfo();
    }
  }, []);
};

export const UserInfo = () => {
  useUserInfo();
  return null;
};
